import { gql } from '@apollo/client'

export const ORDER_MARK_SETTLED_MUTATION = gql`
  mutation orderMarkSettled($input: MarkOrderSettledArgs!) {
    orderMarkSettled(input: $input) {
      _id
      paymentStatus
      updatedAt
    }
  }
`
